'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { ImageFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import OptimizedImage from '@/ui/components/shared/OptimizedImage';

export interface SmartHomeCompatibilityProps {
  icons: ImageFragment[];
}

/**
 * Row of smart-home ecosystem badges (Apple Home, Google Home, …) below the
 * gallery. The badges already say "Works with …" themselves and carry their
 * own alt text from the CMS, so the row has no visible caption.
 */
export function SmartHomeCompatibility({ icons }: Readonly<SmartHomeCompatibilityProps>) {
  const t = useTranslations('ClassicProductDetail');

  if (icons.length === 0) {
    return null;
  }

  return (
    <section aria-label={t('worksWith')} className="mt-6">
      <ul className="flex flex-wrap items-center gap-6 sm:gap-8">
        {icons.map((icon) => (
          <li key={icon.key}>
            <OptimizedImage
              image={icon}
              width={160}
              height={80}
              sizes="160px"
              className="h-12 w-auto sm:h-16"
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
